import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useMutation } from '@sorare/core/src/hooks/graphql/useMutation';

import type {
  lockProModeMutation,
  lockProModeMutationVariables,
} from './__generated__/useLockProModeMutation.graphql';

const LOCK_PRO_MODE_MUTATION = gql`
  mutation lockProModeMutation($input: lockProModeInput!) {
    lockProMode(input: $input) {
      currentUser {
        slug
        forcedIntoOnboarding
        footballUserProfile {
          id
          proUnlocked
        }
      }
      errors {
        message
        code
      }
    }
  }
` as TypedDocumentNode<lockProModeMutation, lockProModeMutationVariables>;

export const useLockProModeMutation = () => {
  return useMutation(LOCK_PRO_MODE_MUTATION, {
    showErrorsWithSnackNotification: true,
  });
};
